import { PreloadAllModules, Routes } from '@angular/router';

export const routes: Routes = [
    {
        path: '',
        redirectTo: 'rt',
        pathMatch: 'full'
    },
    {
        path: 'rt',
        loadComponent: () =>
            import('@qid/gateway').then(
                (m) => m.GatewayPage
            )
    },
    {
        path: 'rt/:qr',
        loadComponent: () =>
            import('@qid/gateway').then(
                (m) => m.GatewayPage
            )
    },
    {
        path: 'join/:shareId',
        loadComponent: () =>
            import('@qid/gateway').then(
                (m) => m.GatewayJoinPage
            )
    },
    {
        path: 'request/:requestId',
        loadComponent: () =>
            import('@qid/gateway').then(
                (m) => m.GatewayRequestPage
            )
    },
    {
        path: 'view-id',
        loadComponent: () =>
            import('@qid/common').then(
                (m) => m.ViewIdPage
            )
    },
    {
        path: 'create-id',
        loadComponent: () =>
            import('@qid/common').then(
                (m) => m.CreateIdPage
            )
    },
    {
        path: 'id-verification',
        loadComponent: () =>
            import('@qid/common').then(
                (m) => m.IdVerificationPage
            )
    },
    {
        path: 'name-correction',
        loadComponent: () => import('@qid/common').then(m => m.NameCorrectionPage)
    },
    {
        path: 'drawer',
        loadComponent: () => import('./pages/drawer/drawer.page').then(m => m.DrawerPage)
    }
];
